<div class="modal-header">
  <label class="col-form-label" style="font-weight: bold">Modificar Artículo "{{ objarticulo.codart }} - {{
    objarticulo.descri }}"
  </label>
  <button (keydown.tab)="onNexFocus('nuevo')" type="button" class="close" aria-label="Close" (click)="cerrar()"
    tabindex="13">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12">
      <div style="text-align: inherit">
        <button (click)="guardar()" tabindex="15" type="button" class="btn btn-rounded btn-info m-b-15">
          <i class="fa fa-save"></i> Guardar
        </button>
        <button (click)="eliminar()" [hidden]="mostrarbotoneliminar" type="button"
          class="btn btn-rounded btn-danger m-b-15">
          <i class="fa fa-trash"></i> Eliminar
        </button>
        <button (click)="cancelar()" (keydown.tab)="onNexFocus('nuevo')" tabindex="16" type="button"
          class="btn btn-rounded btn-warning m-b-15">
          <i class="fa fa-times-circle"></i> Cancelar
        </button>
      </div>

      <div class="card">
        <div class="card-body">
          <ngb-tabset>
            <ngb-tab>
              <ng-template ngbTabTitle>
                <span>Datos generales</span>
              </ng-template>
              <ng-template ngbTabContent>
                <div [hidden]="false">
                  <div class="card-body" style="height: 75vh">
                    <div class="row ">
                      <div class="col-md-12">
                        <!--TIPO DE INVENTARIO-->
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <label
                            for="fname2" class="col-md-3 label-size tsiLabel mt-2">Tipo de inventario:
                          </label>
                          <div class="col-sm-1" style="margin-left: -45px">
                            <input [disabled]="disabledTipoInventario" style="text-align: center" (keydown.enter)="
                                onKeyEnterTipodeInventario($event)
                              " (blur)="onBlurTipodeInventario($event)" class="form-control tsiInput"
                              [(ngModel)]="objarticulo.tipinv" name="inputtipiv" maxlength="2" type="text"
                              onkeypress="return event.charCode >= 8 && event.charCode <= 57" />
                          </div>

                          <div class="col-sm-3">
                            <select [disabled]="disabledTipoInventario" id="cboTipoInventario" tabindex="1"
                              [(ngModel)]="objarticulo.tipinv" name="cobTipoInventario" #selectTipoInventario
                              class="col-sm-12  tsiSelect select_border">
                              <option *ngFor="let lst of tiposInventario" [value]="lst.tipinv">
                                {{ lst.tipinv + " - " + lst.dtipinv }}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>

                        <!--ARTICULO BUSCAR-->

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Artículo:
                          </label>

                          <div class="col-sm-2" style="margin-left: -45px">
                            <input id="inputarticulocodigo" type="text" class="form-control tsiInput" name="codArticulo"
                              [(ngModel)]="objarticulo.codart" [disabled]="disabledArticulo" tabindex="12"
                              (keydown.enter)="onKeyEnterCodigoArticulo($event)" placeholder="Código..."
                              maxlength="40" />
                          </div>

                          <div class="col-sm-6">
                            <input id="desarticulo" type="text" class="form-control tsiInput" name="desarticulo"
                              [disabled]="disabledArticulo" [(ngModel)]="objarticulo.descri" tabindex="2" #desarticulo
                              (keydown.enter)="onKeyEnterArticulo($event)" placeholder="Buscar articulo"
                              maxlength="99" />
                          </div>

                          <div class="col-sm-1">
                            <button *ngIf="buscarArticulo == 'buscar'" class="btn btn-primary btn-sm boton"
                              (click)="openModalArticulo()" type="button" tabindex="3"
                              style="margin-left: -20px !important">
                              <i class="fa fa-search"></i>
                            </button>
                            <button *ngIf="buscarArticulo == 'borrar'" class="btn btn-primary btn-sm boton"
                              (click)="borrarDatosArticulo()" type="button" tabindex="3"
                              style="margin-left: -20px !important">
                              <i class="fas fa-times"></i>
                            </button>
                          </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Descripción de artículo:
                          </label>

                          <div class="col-sm-8" style="margin-left: -45px">
                            <input id="desarticulo" type="text" class="form-control tsiInput" name="desarticulo"
                              [(ngModel)]="objarticulo.descri" tabindex="2" #desarticulo
                              (keydown.enter)="onKeyEnterArticulo($event)" maxlength="99" />
                          </div>
                        </div>


                        <!--UNIDAD DE MEDIDA-->
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <label
                            for="fname2" class="col-md-3 label-size tsiLabel mt-2">Unidad de
                            medida:
                          </label>
                          <div class="col-sm-1" style="margin-left: -45px">
                            <input [disabled]="disabledcampo" style="text-align: center" class="form-control tsiInput"
                              [(ngModel)]="objarticulo.coduni" name="m" maxlength="2" type="text"
                              onkeypress="return event.charCode >= 8 && event.charCode <= 57"
                              class="form-control tsiInput" />
                          </div>
                          <div class="col-sm-3">

                            <select [disabled]="disabledcampo" class="col-sm-12  tsiSelect select_border "
                              [(ngModel)]="objarticulo.coduni" name="moneda"
                              (keydown.enter)="onKeyEnterUnidadesMedida($event)" (blur)="onBlurUnidadesMedida($event)"
                              tabindex="4" id="cboUnidadesMedida" #selectunidadesMedidas>
                              <option *ngFor="let lst of unidadesMedidas" [value]="lst.coduni">
                                {{ lst.coduni + " - " + lst.desuni }}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>

                        <!--FECHA DE MATRICULA-->
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Fecha de matrícula:
                          </label>
                          <div class="col-sm-2" style="margin-left: -45px">
                            <input [disabled]="disabledcampo" class="form-control" id="fechaMatricula"
                              name="fechaMatricula" [(ngModel)]="objarticulo.fmatri" type="date" max="2999-01-01"
                              tabindex="5" style="text-align: center !important" class="form-control tsiInput" />
                          </div>
                          <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>

                        <!--CONTROL DE STOCK-->
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <label
                            for="fname2" class="col-md-3 label-size tsiLabel mt-2">Control de stock:
                          </label>
                          <div class="col-sm-4" style="margin-left: -45px">
                            <select [disabled]="disabledcampo" class="col-sm-12 tsiSelect  select_border"
                              [(ngModel)]="objarticulo.consto" name="consto" tabindex="6">
                              <option *ngFor="let lst of tipoControlStock" [value]="lst.tipo">
                                {{ lst.tipo + " - " + lst.descripcion }}
                              </option>
                            </select>

                            <!--
                            <input [disabled]="disabledcampo" (keydown.enter)="retornarEnter($event)"
                                class="form-control tsiInput" #inputControlStock id="controlStock" name="controlStock"
                                [(ngModel)]="objarticulo.consto" (keyup)="keyUpControlStock(inputControlStock.value)"
                                (change)="keyUpControlStock(inputControlStock.value)" style="text-align: center !important;"
                                width="30px" type="number" max="8" min="0" tabindex="6"> -->
                          </div>
                        </div>

                        <!--FACTOR DE CONVERSION-->
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <label
                            for="fname2" class="col-md-3 label-size tsiLabel mt-2">Factor conversión:
                          </label>
                          <div class="col-sm-2" style="margin-left: -45px">
                            <input [disabled]="disabledcampo" (keydown.enter)="retornarEnter($event)"
                              class="form-control tsiInput" id="factorConversion" name="factorConversion" #factorVal
                              (blur)="
                                asignarDecimalesFacConversion(
                                  objarticulo.faccon
                                )
                              " [(ngModel)]="objarticulo.faccon" style="
                                text-transform: uppercase;
                                border-color: gray;
                              " tabindex="7" maxlength="5"
                              onkeypress="return event.charCode >= 8 && event.charCode <= 57" />
                          </div>
                          <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>

                        <!--CHECKBOX-->
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-3 text-left control-label">
                          </label>
                          <div class="form-group row col-sm-2" style="margin-left: -25px">
                            <input type="checkbox" class="form-check-input m-l-3" id="exampleCheck1"
                              [(ngModel)]="inputAgrupa" name="activo" tabindex="8" />
                            <label class="tsiLabel form-check-label m-t-5" for="exampleCheck1">Agrupa</label>
                          </div>
                          <div class="form-group row d-flex col-sm-3" style="margin-left: 2em">
                            <input type="checkbox" class="form-check-input m-l-3" id="exampleCheck2"
                              [(ngModel)]="inputPagoAdelantado" name="activo" tabindex="9" />
                            <label class="tsiLabel form-check-label m-t-5" for="exampleCheck2">Obliga pago
                              adelantado</label>
                          </div>
                        </div>

                        <!--CODIGO DE BARRA-->
                        <div class="form-group row d-flex align-items-center"
                          style="margin-top: -10px; margin-bottom: 0;">
                          <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Código de barra:
                          </label>
                          <div class="col-sm-4" style="margin-left: -45px">
                            <input [disabled]="disabledcampo" data-original-title="Máximo 40 carácteres"
                              data-toggle="tooltip" (keydown.enter)="retornarEnter($event)" tabindex="10"
                              class="form-control tsiInput" id="codBarra" name="codBarra" placeholder="Código de barra"
                              [(ngModel)]="objarticulo.codbar" type="text" class="form-control tsiInput"
                              maxlength="30" />
                          </div>
                        </div>




                        <!--COMENTARIO Y APLICACION -->
                        <!-- <div class="form-group row mb-1" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-3 text-left control-label">Comentario/Aplicación:
                                                    </label>
                                                    <div class="col-sm-8" style="margin-left:-45px">
                                                        <textarea type="text" [disabled]="disabledcampo"
                                                            data-original-title="Máximo 249 carácteres"
                                                            data-toggle="tooltip" (keydown.enter)="retornarEnter($event)"
                                                            class="form-control tsiInput" id="comentarioApp"
                                                            name="comentarioApp" placeholder="Comentario"
                                                            [(ngModel)]="objarticulo.wglosa" class="form-control tsiInput"
                                                            tabindex="11" maxlength="70"></textarea>
                                                    </div>
                                                </div> -->

                        <!--PROVEEDOR-->
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Proveedor:
                          </label>

                          <div class="col-sm-2" style="margin-left: -45px">
                            <input [disabled]="disabledcampo" id="inputinterlocutorcodigo" type="text"
                              class="form-control tsiInput" name="desInterlocutor" [(ngModel)]="objarticulo.codprv"
                              [disabled]="disabledProveedor" (keydown.enter)="onKeyEnterCodProveedor($event)"
                              placeholder="Código" maxlength="15" />
                          </div>

                          <div class="col-sm-6">
                            <input [disabled]="disabledcampo" id="inputinterlocutornombre" type="text"
                              class="form-control tsiInput" name="codInterlocutor" [(ngModel)]="desProveedor"
                              [disabled]="disabledProveedor" tabindex="12" #provee
                              (keydown.enter)="onKeyEnterProveedor($event)" placeholder="Buscar proveedor..."
                              maxlength="40" />
                          </div>

                          <div class="col-sm-1">
                            <button *ngIf="buscarProveedor == 'buscar'" class="btn btn-primary btn-sm boton"
                              (click)="openModalProveedor()" type="button" tabindex="13"
                              style="margin-left: -20px !important">
                              <i class="fa fa-search"></i>
                            </button>
                            <button *ngIf="buscarProveedor == 'borrar'" class="btn btn-primary btn-sm boton"
                              (click)="borrarDatosProveedor()" type="button" tabindex="13"
                              style="margin-left: -20px !important">
                              <i class="fas fa-times"></i>
                            </button>
                          </div>
                        </div>

                        <!--CODIGO DE FABRICANTE-->
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Código de fabricante/marca:
                          </label>
                          <div class="col-sm-5" style="margin-left: -45px">
                            <input [disabled]="disabledcampo" data-original-title="Máximo 50 carácteres"
                              data-toggle="tooltip" (keydown.enter)="retornarEnter($event)"
                              class="form-control form-control-sm" id="codFabricante" name="codFabricante"
                              [(ngModel)]="objarticulo.proart" type="text" class="form-control tsiInput"
                              placeholder="Código de fabricante" tabindex="14" maxlength="40" #codFabri />
                          </div>
                        </div>

                        <!--CODIGO DE FABRICANTE-->
                        <div class="form-group row d-flex align-items-center">
                          <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Código OEM:
                          </label>
                          <div class="col-sm-4" style="margin-left: -45px">
                            <input [disabled]="disabledcampo" data-original-title="Máximo 50 carácteres"
                              data-toggle="tooltip" class="form-control form-control-sm" id="codoem" name="codoem"
                              [(ngModel)]="objarticulo.codoem" type="text" class="form-control tsiInput"
                              placeholder="Código OEM" tabindex="14" maxlength="50" #codoem />
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-3 label-size tsiLabel">Comentario/Aplicación:
                          </label>
                          <div class="col-md-5 input-group" style="margin-left: -45px">
                            <textarea class="form-control form-control-sm" rows="6" name="glosa" maxlength="240"
                              [(ngModel)]="objarticulo.wglosa" style="border-color: gray" tabindex="220"></textarea>
                          </div>
                        </div>

                        <hr />
                        <div class="form-group row mb-1 col-lg-12 justify-content-center">
                          <label for="fname2" class="text-left control-label col-md-3">Fecha creación:
                            {{ objarticulo.fcreac | date : "dd/MM/yyyy" }}
                          </label>

                          <!-- <input  type="date" [(ngModel)]="objCliente.factua" disabled
                                                                    class="focus-input input_border form-control tsiInput col-sm-1"
                                                                   > -->

                          <label for="fname2" class="text-left control-label col-md-3">Usuario: {{ objarticulo.ucreac }}
                          </label>

                          <!--  <input  type="text" [(ngModel)]="objCliente.ucreac" disabled
                                                                    class="focus-input input_border form-control  tsiInput col-sm-2"> -->

                          <label for="fname2" class="text-left control-label col-md-3">Fecha Actualización:
                            {{ objarticulo.factua | date : "dd/MM/yyyy" }}
                          </label>

                          <!--  <input  type="date"  [(ngModel)]="objCliente.fcreac" disabled
                                                                    class="focus-input input_border form-control  tsiInput col-sm-1"> -->

                          <label for="fname2" class="text-left control-label col-md-3">Usuario: {{ objarticulo.uactua }}
                          </label>
                          <!-- <input  type="text" [(ngModel)]="objCliente.uactua" disabled
                                                                    class="focus-input input_border form-control  tsiInput col-sm-2"> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-tab>

            <ngb-tab *ngIf="tabclases">
              <ng-template ngbTabTitle> <span>Clases</span></ng-template>
              <ng-template ngbTabContent>
                <div [hidden]="viewInterfazClasesPrin != 1">
                  <button type="button" class="btn btn-rounded btn-success" style="margin-top: 20px"
                    (click)="openNuevoClase(modalnuevaclase)">
                    <i class="fa fa-plus"></i> Nuevo
                  </button>

                  <div class="table-responsive" style="height: 50vh">
                    <table class="table table-sm table-striped table-bordered table-hover" style="margin-top: 30px">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Clase</th>
                          <th>Descripción</th>
                          <th>Código</th>
                          <th>Descripción</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of clases">
                          <td scope="row" style="
                              display: table-cell;
                              text-align: center;
                              padding-bottom: 0px;
                            ">
                            <div class="btn-group btn-group-xs" role="group" style="margin: 0px; padding: 0px">
                              <button type="button" class="btn btn-sm" (click)="openUpdate(item, modalnuevaclase)"
                                style=" border: none; outline: none;">
                                <span class="fas fa-pencil-alt" aria-hidden="true"></span>
                              </button>
                              <button type="button" class="btn btn-sm" (click)="EliminarClase(item)"
                                style=" border: none; outline: none;">
                                <span class="fas fa-trash-alt" aria-hidden="true"></span>
                              </button>
                            </div>
                          </td>
                          <td scope="row">{{ item.clase }}</td>
                          <td style="white-space: nowrap">
                            {{ item.desclase }}
                          </td>
                          <td>{{ item.codigo }}</td>
                          <td style="white-space: nowrap">
                            {{ item.descodigo }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-template>
            </ngb-tab>

            <ng-template #modalnuevaclase let-modal>
              <div class="">
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 *ngIf="newClase" class="modal-title">
                      <b>Nueva clase</b>
                    </h4>
                    <h4 *ngIf="!newClase" class="modal-title">
                      <b>Editar clase</b>
                    </h4>

                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"
                      tabindex="200">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body pl-4">
                    <form>
                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <label for="fname2" class="col-md-1 label-size tsiLabel mt-2">Clase:</label>
                        <div class="col-sm-2">
                          <input style="text-align: center" class="form-control tsiInput" name="codClase" type="text"
                            tabindex="201" (blur)="
                              onChangeNuevaClase(
                                $event,
                                objClaseCodigoDescripcion.clase
                              )
                            " onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                            [(ngModel)]="objClaseCodigoDescripcion.clase" />
                        </div>
                        <div class="col-sm-6">
                          <select tabindex="202" class="col-sm-12 tsiSelect"
                            [(ngModel)]="objClaseCodigoDescripcion.clase" name="codClase" #selectClase (change)="
                              onChangeNuevaClase(
                                $event,
                                objClaseCodigoDescripcion.clase
                              )
                            ">
                            <option *ngFor="let lst of clasesSelect" [value]="lst.codigo">
                              {{ lst.codigo + " - " + lst.descri }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <label for="fname2" class="col-md-1 label-size tsiLabel mt-2">Código:</label>
                        <div class="col-sm-2">
                          <input style="text-align: center" class="form-control tsiInput" name="codCodigo" type="text"
                            tabindex="203" disabled onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            maxlength="10" [(ngModel)]="objClaseCodigoDescripcion.codigo" />
                        </div>
                        <div class="input-group col-md-11">
                          <select tabindex="204" disabled class="form-control tsiSelect col-md-6"
                            [(ngModel)]="objClaseCodigoDescripcion.codigo" name="codCodigo" #selectClase>
                            <option *ngFor="let lst of clasesCodigos" [value]="lst.codigo">
                              {{ lst.descri }}
                            </option>
                          </select>
                          <div class="input-group-append " style="width:40px">
                            <button *ngIf="buscarcodCla == 'buscar'" class="btn btn-primary btn-sm boton"
                              (click)="openModalCodCla()" type="button" tabindex="3">
                              <i class="fa fa-search"></i>
                            </button>
                            <button *ngIf="buscarcodCla == 'borrar'" class="btn btn-primary btn-sm boton"
                              (click)="borrarDatosCodCla()" type="button" tabindex="3">
                              <i class="fas fa-times"></i>
                            </button>
                          </div>
                        </div>

                      </div>
                    </form>
                  </div>
                  <div class="modal-footer">
                    <button *ngIf="newClase" type="button" class="btn btn-rounded btn-success m-b-15"
                      (click)="guardarClase()" tabindex="205">
                      <i class="fas fa-angle-double-right"></i> Continuar
                    </button>
                    <button *ngIf="!newClase" type="button" class="btn btn-rounded btn-success m-b-15"
                      (click)="edtarClase()" tabindex="205">
                      <i class="fas fa-angle-double-right"></i> Guardar
                    </button>

                    <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertclass()"
                      (click)="modal.close('Save click')" tabindex="206">
                      <i class="fa fa-times-circle"></i> Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template #modalactualizarclase let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Modificar Clase:
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <!---->
                          <label for="fname2" class="col-md-1 label-size tsiLabel mt-2">Clase:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codClase" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseCodigoDescripcion.clase" disabled />
                          </div>
                          <div class="col-sm-4">
                            <!--  <select disabled tabindex="15" class="custom-select"  class="form-control tsiInput"  [(ngModel)]="objClaseCodigoDescripcion.clase"
                                name="codClase" #selectClase  style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                >
                                <option *ngFor="let lst of clasesSelect " [value]="lst.codigo" >
                                {{lst.codigo+' - '+lst.descri}}
                                </option>
                            </select> -->
                            <input style="text-align: center" class="form-control t" name="desClase" type="text"
                              [(ngModel)]="objClaseCodigoDescripcion.desclase" disabled />
                          </div>

                          <!---->
                          <label for="fname2" class="col-md-1 label-size tsiLabel mt-2">Código:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codigo" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseCodigoDescripcion.codigo" />
                          </div>
                          <div class="col-sm-4">
                            <select tabindex="15" class="col-sm-12  tsiSelect"
                              [(ngModel)]="objClaseCodigoDescripcion.codigo" name="codigo" #selectClase style="
                                margin-bottom: 12px !important ;
                                padding-top: 0px !important;
                              ">
                              <option *ngFor="let lst of clasesCodigos" [value]="lst.codigo">
                                {{ lst.codigo + " - " + lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarActualizarClase()"
                  tabindex="5">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertclass()"
                  (click)="modal.close('Save click')" tabindex="6">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>

            <ngb-tab *ngIf="tabespecificaciones">
              <ng-template ngbTabTitle>
                <span>Especificaciones</span></ng-template>
              <ng-template ngbTabContent>
                <div [hidden]="viewInterfazClasesPrin != 1">
                  <button type="button" class="btn btn-rounded btn-success" style="margin-top: 20px"
                    (click)="openNuevoEspecificacion()">
                    <i class="fa fa-plus"></i> Nuevo
                  </button>

                  <div class="table-responsive" style="height: 50vh">
                    <table class="table table-sm table-striped table-bordered table-hover" style="margin-top: 30px">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Código</th>
                          <th>Descripción</th>
                          <th>Decimal</th>
                          <th>Cadena</th>
                          <th>Caracter</th>
                          <th>Fecha</th>
                          <th>Hora</th>
                          <th>Entero</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of especificaciones">
                          <td scope="row" style="
                              display: table-cell;
                              text-align: center;
                              padding-bottom: 0px;
                            ">
                            <div class="btn-group btn-group-xs" role="group" style="margin: 0px; padding: 0px">
                              <button type="button" class="btn btn-sm" (click)="
                                  openModificarEspecificacion(
                                    modalactualizarespecificacion,
                                    item
                                  ) 
                                " style=" border: none; outline: none;">
                                <span class="fas fa-pencil-alt" aria-hidden="true"></span>
                              </button>
                              <button type="button" class="btn btn-sm" (click)="EliminarEspecificacion(item)"
                                style=" border: none; outline: none;">
                                <span class="fas fa-trash-alt" aria-hidden="true"></span>
                              </button>
                            </div>
                          </td>
                          <td scope="row">{{ item.codesp }}</td>
                          <td style="white-space: nowrap">{{ item.descri }}</td>
                          <td>{{ item.vreal }}</td>
                          <td>{{ item.vstrg }}</td>

                          <td>{{ item.vchar }}</td>
                          <td>{{ item.vdate }}</td>
                          <td>{{ item.vtime }}</td>
                          <td>{{ item.ventero }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-template>
            </ngb-tab>

            <ng-template #modalnuevaespecificacion let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  <i class="fa fa-plus"></i> Nuevo:
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <!---->
                          <div *ngIf="disabledDecimal == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel">Decimal:</label>
                            <input class="col-md-3 form-control tsiInput m-r-5" id="decimal" name="decimal"
                              [(ngModel)]="decimal" type="text" style="margin-right: 0.5rem" />
                          </div>
                          <!-- Nueva especificacion -->
                          <div *ngIf="disabledTexto == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel">Cadena:</label>
                            <input class="form-control tsiInput" id="texto" name="texto" [(ngModel)]="texto"
                              type="text" />
                          </div>

                          <div *ngIf="disabledCaracter == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel">Caracter:</label>
                            <input class="form-control tsiInput col-md-2" id="caracter" name="caracter"
                              [(ngModel)]="caracter" type="text" style="text-transform: uppercase" />
                          </div>

                          <div *ngIf="disabledFecha == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel">Fecha:</label>
                            <input class="form-control tsiInput col-md-4" id="fecha" name="fecha" [(ngModel)]="fecha"
                              type="date" max="2999-01-01" />
                          </div>

                          <div *ngIf="disabledTiempo == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel">Hora:</label>
                            <input class="form-control tsiInput col-md-2" id="tiempo" name="tiempo" [(ngModel)]="tiempo"
                              type="time" style="text-transform: uppercase" />
                          </div>

                          <div *ngIf="disabledNumero == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel">Entero:</label>
                            <input class="form-control tsiInput col-md-2" id="numero" name="numero" [(ngModel)]="numero"
                              type="text" style="text-transform: uppercase" />
                          </div>
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarEspecificacion()"
                  tabindex="5">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertEspecificacion()"
                  (click)="modal.close('Save click')" tabindex="6">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>

            <ng-template #modalactualizarespecificacion let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Modificar especificacion
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <div class="row pl-4">
                      <div class="col-md-12">
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0">
                          <!---->
                          <div *ngIf="disabledDecimal == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel">Decimal:</label>
                            <input class="col-md-3 form-control tsiInput m-r-5" id="decimal" name="decimal"
                              [(ngModel)]="objClaseCodigoEspecifi.vreal" type="text" style="margin-right: 0.5rem" />
                          </div>
                          <!-- Actualizar texto -->
                          <div *ngIf="disabledTexto == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel">Cadena:</label>
                            <input class="form-control tsiInput" id="texto" name="texto"
                              [(ngModel)]="objClaseCodigoEspecifi.vstrg" type="text" />
                          </div>

                          <div *ngIf="disabledCaracter == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel mt-2">Caracter:</label>
                            <input class="form-control tsiInput col-md-2" id="caracter" name="caracter"
                              [(ngModel)]="objClaseCodigoEspecifi.vchar" type="text"
                              style="text-transform: uppercase" />
                          </div>

                          <div *ngIf="disabledFecha == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel">Fecha:</label>
                            <input class="form-control tsiInput col-md-4" id="fecha" name="fecha"
                              [(ngModel)]="objClaseCodigoEspecifi.vdate" type="date" max="2999-01-01" />
                          </div>

                          <div *ngIf="disabledTiempo == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel">Hora:</label>
                            <input class="form-control tsiInput col-md-2" id="tiempo" name="tiempo"
                              [(ngModel)]="objClaseCodigoEspecifi.vtime" type="time"
                              style="text-transform: uppercase" />
                          </div>

                          <div *ngIf="disabledNumero == true" class="input-group">
                            <label class="col-md-2 label-size tsiLabel">Entero:</label>
                            <input class="form-control tsiInput col-md-2" id="numero" name="numero"
                              [(ngModel)]="objClaseCodigoEspecifi.ventero" type="text"
                              style="text-transform: uppercase" />
                          </div>
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15"
                  (click)="guardarActualizarEspecificacion()" tabindex="5">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertEspecificacion()"
                  (click)="modal.close('Save click')" tabindex="6">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>
            <ngb-tab *ngIf="tabimagenes">
              <ng-template ngbTabTitle> <span>Imágenes</span></ng-template>
              <ng-template ngbTabContent>



                <div *ngIf="tab == 'imagenes'" class="ibox-head" style="margin-top: 20px;">




                  <div class="row">
                    <div class="col-md-12">
                      <input #fileUpload type="file" id="file" accept=".jpg" (change)="uploadImage($event)">
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-4 ">
                      <div [hidden]="false">
                        <form>
                          <div class="form-row col-md-12">
                            <div style="margin: 40px;">
                              <img class="card-img-top img-fluid" [src]="imagenAdjunto" width="100" height="50"
                                (error)="sinImagenAdjunto()">
                              <!-- (error)="sinImagenAdjunto()"-->
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>


                    <div class="col-md-4 " style="margin: auto 0;">
                      <ul>
                        <li>Formato : JPG</li>
                        <li>Peso máximo : 1Mb</li>
                        <li>Ancho recomendado : 600px</li>
                        <li>Largo recomendado : 400px</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <hr>


                <div class="img-array-container col-md-12 " style="margin-top: 3rem;">
                  <div *ngFor="let imagen of arregloPrueba; let i = index;">
                    <div class="image-articulo-container " (click)="deleteImagen(i)">
                      <img [src]="imagen" alt="Card image cap">
                      <i class="fas fa-trash-alt"></i>
                    </div>
                  </div>
                </div>


              </ng-template>
            </ngb-tab>

            <ngb-tab *ngIf="tabclasesglobales">
              <ng-template ngbTabTitle>
                <span>Clases alternativas</span></ng-template>
              <ng-template ngbTabContent>
                <div [hidden]="viewInterfazClasesPrin != 1">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-3" style="margin-top: 20px">
                          <button type="button" class="btn btn-rounded btn-success" (click)="
                              openNuevoClaseAlternativa(
                                modalnuevaclaseAlternativa
                              )
                            ">
                            <i class="fa fa-plus"></i> Nuevo
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover" style="margin-top: 30px">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Clase</th>
                          <th>Descripción</th>
                          <th>Código</th>
                          <th>Descripción</th>
                          <th>Caracter</th>
                          <th>Real</th>
                          <th>String</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of clasesAlternativas">
                          <td scope="row" style="
                              display: table-cell;
                              text-align: center;
                              padding-bottom: 0px;
                            ">
                            <div class="btn-group btn-group-xs" role="group" style="margin: 0px; padding: 0px">
                              <button type="button" class="btn btn-sm" (click)="
                                  openModificarClaseAlt(
                                    modalactualizarAlternativa,
                                    item
                                  )
                                " style=" border: none; outline: none;">
                                <span class="fas fa-pencil-alt" aria-hidden="true"></span>
                              </button>
                              <button type="button" class="btn btn-sm" (click)="EliminarClaseAlt(item)"
                                style=" border: none; outline: none;">
                                <span class="fas fa-trash-alt" aria-hidden="true"></span>
                              </button>
                            </div>
                          </td>
                          <td scope="row">{{ item.clase }}</td>
                          <td style="white-space: nowrap">
                            {{ item.desclase }}
                          </td>
                          <td>{{ item.codigo }}</td>
                          <td style="white-space: nowrap">
                            {{ item.descodigo }}
                          </td>
                          <td>{{ item.vchar }}</td>
                          <td>{{ item.vreal }}</td>
                          <td>{{ item.vstrg }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-template>
            </ngb-tab>
            <!-- <ngb-tab *ngIf=tabclasesglobales>
                            <ng-template ngbTabTitle> <span>Clases globales</span></ng-template>
                            <ng-template ngbTabContent>

                                <div [hidden]="viewInterfazClasesPrin != 1">


                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="row" style="margin-top: 10px !important;">
                                                <div class="col-md-3" style="margin-top: 10px;">
                                                    <button type="button" class="btn btn-rounded btn-success m-b-15"
                                                        (click)="openNuevoClaseGlobal(modalnuevaclaseGlobal)"><i
                                                            class="fa fa-plus"></i>
                                                        Nuevo</button>
                                                </div>

                                                <div class="col-md-3" style="margin-top: 10px; margin-left: -120px;">
                                                    <button disabled type="button"
                                                        class="btn btn-rounded btn-success m-b-15"
                                                        (click)="openNuevoClaseGlobalUNSPSC(modalnuevaclaseGlobalUNSPSC)"><i
                                                            class="fa fa-plus"></i>
                                                        Nuevo UNSPSC</button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Clase</th>
                                                    <th>Descripción</th>
                                                    <th>Código</th>
                                                    <th>Descripción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of clasesGlobales">
                                                    <td scope="row"
                                                        style="display: table-cell; text-align: center; padding-bottom: 0px;">
                                                        <div class="btn-group btn-group-xs" role="group"
                                                            style="margin: 0px;padding: 0px;">
                                                            <button type="button" class="btn btn-sm"
                                                                (click)="openModificarClaseGlobal(modalactualizarGlobal, item)"><span
                                                                    class="fas fa-pencil-alt"
                                                                    aria-hidden="true"></span></button>
                                                            <button type="button" class="btn btn-sm "
                                                                (click)="EliminarClaseGlobal(item)"><span
                                                                    class="fas fa-trash-alt"
                                                                    aria-hidden="true"></span></button>
                                                        </div>
                                                    </td>
                                                    <td scope="row">{{ item.clase }}</td>
                                                    <td style="white-space: nowrap;">{{ item.desclase }}</td>
                                                    <td>{{ item.codigo }}</td>
                                                    <td style="white-space: nowrap;">{{ item.descodigo }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>

                            </ng-template>
                        </ngb-tab> -->
            <ng-template #modalnuevaclaseAlternativa let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Nueva clase alternativa
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"
                  tabindex="300">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body pl-4">
                <form>
                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                    <label for="fname2" class="col-md-1 label-size tsiLabel mt-2">Clase:</label>
                    <div class="col-sm-1">
                      <input style="text-align: center" class="form-control tsiInput" name="codClase" type="text"
                        tabindex="301" (blur)="onBlurSelectClases($event.target.value)"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                        [(ngModel)]="objClaseAltenativa.clase" />
                    </div>
                    <div class="col-sm-6">
                      <select tabindex="302" class="col-sm-12  tsiSelect " [(ngModel)]="objClaseAltenativa.clase"
                        name="codClase" #selectClase (change)="onBlurSelectClases($event.target.value)">
                        <option *ngFor="let lst of clasesAlternativasSelect" [value]="lst.clase">
                          {{ lst.clase + " - " + lst.descri }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                    <label for="fname2" class="col-md-1 label-size tsiLabel mt-2">Código:</label>
                    <div class="col-sm-2">
                      <input style="text-align: center" class="form-control tsiInput" name="codCodigoGlobal" type="text"
                        tabindex="303" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                        [(ngModel)]="objClaseAltenativa.codigo" />
                    </div>
                    <div class="col-sm-6">
                      <select tabindex="304" class="col-sm-12  tsiSelect" [(ngModel)]="objClaseAltenativa.codigo"
                        name="codCodigoGlobal" #selectClaseGlobal>
                        <option *ngFor="let lst of unidadesMedidas" [value]="lst.coduni">
                          {{ lst.coduni + " - " + lst.desuni }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- <div [hidden]="disabledCodigo" class="input-group">
                                                    <label style="margin-right: 2.2rem">Código</label>
                                                    <input class="col-md-2 form-control form-control-sm m-r-5"
                                                        id="codCodigoClase" name="codCodigoClase" [(ngModel)]="objClaseAltenativa."
                                                        type="text" maxlength="3" style="text-transform:uppercase;">
                                                </div>
         -->
                  <div [hidden]="disabledReal" class="form-group row pl-2 mt-2">
                    <label for="fname2" style="padding: 0.2em 0em 0em 0.5em;"
                      class="col-sm-1 control-label col-form-label tsiLabel">V. Real:</label>
                    <div class="col-sm-5" style="margin-left: -5px;">
                      <input class="form-control tsiInput" id="vReal" name="vReal"
                        [(ngModel)]="objClaseAltenativa.vreal" type="text" maxlength="12" />
                    </div>
                  </div>

                  <div [hidden]="disabledString" class="form-group row pl-2 mt-2">
                    <label for="fname2" style="padding: 0.2em 0em 0em 0.5em"
                      class="col-sm-1 control-label col-form-label tsiLabel">V. String:</label>
                    <div class="col-sm-5" style="margin-left: -5px;">
                      <input class="form-control tsiInput" id="vString" name="vString"
                        [(ngModel)]="objClaseAltenativa.vstrg" type="text" maxlength="30" />
                    </div>
                  </div>

                  <div [hidden]="disabledCaracter" class="form-group row pl-2 mt-2">
                    <label for="fname2" style="padding: 0.2em 0em 0em 0.5em"
                      class="col-sm-1 control-label col-form-label tsiLabel">V. Char:</label>
                    <div class="col-sm-3" style="margin-left: -5px;">
                      <input class="form-control tsiInput" id="vChar" name="vChar"
                        [(ngModel)]="objClaseAltenativa.vchar" type="text" maxlength="1" />
                    </div>
                  </div>

                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarClaseAlt()"
                  tabindex="305">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertclassGlobal()"
                  (click)="modal.close('Save click')" tabindex="306">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>

            <ng-template #modalactualizarAlternativa let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Modificar clase alternativa
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body pl-4">
                <form>

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <!---->
                    <label for="fname2" class="col-md-1 label-size tsiLabel mt-2">Clase:</label>
                    <div class="col-sm-1">
                      <input disabled style="text-align: center" class="form-control tsiInput" name="codClase"
                        type="text" tabindex="301" (blur)="onBlurSelectClases($event.target.value)"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                        [(ngModel)]="objClaseAltenativa.clase" />
                    </div>
                    <div class="col-sm-6">
                      <select disabled tabindex="302" class="col-sm-12  tsiSelect"
                        [(ngModel)]="objClaseAltenativa.clase" name="codClase" #selectClase
                        (change)="onBlurSelectClases($event.target.value)">
                        <option *ngFor="let lst of clasesAlternativasSelect" [value]="lst.clase">
                          {{ lst.clase + " - " + lst.descri }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <!---->
                    <label for="fname2" class="col-md-1 label-size tsiLabel mt-2">Código:</label>
                    <div class="col-sm-2">
                      <input style="text-align: center" class="form-control tsiInput" name="codCodigoGlobal" type="text"
                        tabindex="303" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                        [(ngModel)]="objClaseAltenativa.codigo" />
                    </div>
                    <div class="col-sm-6">
                      <select tabindex="304" class="col-sm-12  tsiSelect" [(ngModel)]="objClaseAltenativa.codigo"
                        name="codCodigoGlobal" #selectClaseGlobal>
                        <option *ngFor="let lst of unidadesMedidas" [value]="lst.coduni">
                          {{ lst.coduni + " - " + lst.desuni }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- <div [hidden]="disabledCodigo" class="input-group">
                                                    <label style="margin-right: 2.2rem">Código</label>
                                                    <input class="col-md-2 form-control form-control-sm m-r-5"
                                                        id="codCodigoClase" name="codCodigoClase" [(ngModel)]="objClaseAltenativa."
                                                        type="text" maxlength="3" style="text-transform:uppercase;">
                                                </div>
         -->
                  <div [hidden]="disabledReal" class="form-group row pl-2 mt-2">

                    <label for="fname2" style="padding: 0.2em 0em 0em 0.5em;"
                      class="col-sm-1 control-label col-form-label tsiLabel">V. Real:</label>
                    <div class="col-sm-5" style="margin-left: -5px;">
                      <input class="form-control tsiInput" id="vReal" name="vReal"
                        [(ngModel)]="objClaseAltenativa.vreal" type="text" maxlength="12" />
                    </div>
                  </div>

                  <div [hidden]="disabledString" class="form-group row pl-2 mt-2">

                    <label for="fname2" style="padding: 0.2em 0em 0em 0.5em;"
                      class="col-sm-1 control-label col-form-label tsiLabel">V. String:</label>
                    <div class="col-sm-5" style="margin-left: -5px;">
                      <input class="form-control tsiInput" id="vString" name="vString"
                        [(ngModel)]="objClaseAltenativa.vstrg" type="text" maxlength="30" />
                    </div>
                  </div>

                  <div [hidden]="disabledCaracter" class="form-group row pl-2 mt-2">

                    <label for="fname2" style="padding: 0.2em 0em 0em 0.5em;"
                      class="col-sm-1 control-label col-form-label tsiLabel">V. Char:</label>
                    <div class="col-sm-3" style="margin-left: -5px;">
                      <input class="form-control tsiInput" id="vChar" name="vChar"
                        [(ngModel)]="objClaseAltenativa.vchar" type="text" maxlength="1" />
                    </div>

                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarActualizarClaseAlt()"
                  tabindex="5">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertclassGlobal()"
                  (click)="modal.close('Save click')" tabindex="6">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>

            <ng-template #modalnuevaclaseGlobal let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Nueva Clase Global:
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"
                  tabindex="300">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row" style="margin-bottom: 0.5rem">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em 0.5em"
                            class="col-sm-1 control-label col-form-label tsiLabel">Clase:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codClase" type="text"
                              tabindex="301" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              maxlength="3" [(ngModel)]="objClaseGlobal.clase" />
                          </div>
                          <div class="col-sm-6">
                            <select tabindex="302" class="col-sm-12 tsiSelect" [(ngModel)]="objClaseGlobal.clase"
                              name="codClase" #selectClase style="
                                margin-bottom: 12px !important ;
                                padding-top: 0px !important;
                              " (change)="
                                onChangeNuevaClaseGlobal(
                                  $event,
                                  objClaseGlobal.clase
                                )
                              ">
                              <option *ngFor="let lst of clasesGlobalesSelect" [value]="lst.codigo">
                                {{ lst.codigo + " - " + lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0.5rem">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em 0.5em"
                            class="col-sm-1 control-label col-form-label tsiLabel">Código:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codCodigoGlobal"
                              type="text" tabindex="303"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseGlobal.codigo" />
                          </div>
                          <div class="col-sm-6">
                            <select tabindex="304" class="col-sm-12  tsiInput" [(ngModel)]="objClaseGlobal.codigo"
                              name="codCodigoGlobal" #selectClaseGlobal style="
                                margin-bottom: 12px !important ;
                                padding-top: 0px !important;
                              ">
                              <option *ngFor="let lst of clasesCodigosGlobal" [value]="lst.codigo">
                                {{ lst.codigo + " - " + lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarClaseGlobal()"
                  tabindex="305">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertclassGlobal()"
                  (click)="modal.close('Save click')" tabindex="306">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>

            <ng-template #modalactualizarGlobal let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Modificar Clase Global:
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row" style="margin-bottom: 0.5rem">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em 0.5em"
                            class="col-sm-1 control-label col-form-label tsiLabel">Clase:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codClase" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseGlobal.clase" disabled />
                          </div>
                          <div class="col-sm-4">
                            <input style="text-align: center" class="form-control tsiInput" name="desClase" type="text"
                              [(ngModel)]="objClaseGlobal.desclase" disabled />
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0.5rem">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em 0.5em"
                            class="col-sm-1 control-label col-form-label tsiLabel">Código:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codigo" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseGlobal.codigo" />
                          </div>
                          <div class="col-sm-4">
                            <select tabindex="15" class="col-sm-12  tsiSelect" [(ngModel)]="objClaseGlobal.codigo"
                              name="codigo" #selectClase style="
                                margin-bottom: 12px !important ;
                                padding-top: 0px !important;
                              ">
                              <option *ngFor="let lst of clasesCodigosGlobal" [value]="lst.codigo">
                                {{ lst.codigo + " - " + lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15"
                  (click)="guardarActualizarClaseGlobal()" tabindex="5">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertclassGlobal()"
                  (click)="modal.close('Save click')" tabindex="6">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>

            <ng-template #modalnuevaclaseGlobalUNSPSC let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Nueva Clase UNSPSC: (EN DESARROLLO)
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row" style="margin-bottom: 0.5rem">
                          <!---->
                          <label for="fname2" style="
                              padding: 0.2em 0em 0em 0.5em;
                              margin-left: 25px;
                            " class="col-sm-2 control-label col-form-label tsiLabel">UNSPSC:</label>
                          <div class="col-sm-4">
                            <input style="text-align: center" class="form-control tsiInput" name="codClase" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseGlobal.clase" />
                          </div>
                        </div>
                        <div class="form-group row" style="margin-bottom: 0.5rem">
                          <!---->
                          <label for="fname2" style="
                              padding: 0.2em 0em 0em 0.5em;
                              margin-left: 25px;
                            " class="col-sm-2 control-label col-form-label tsiLabel">Clase:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codClase" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseGlobal.clase" />
                          </div>
                          <div class="col-sm-6">
                            <select tabindex="15" class="col-sm-12  tsiSelect" [(ngModel)]="objClaseGlobal.clase"
                              name="codClase" #selectClase style="
                                margin-bottom: 12px !important ;
                                padding-top: 0px !important;
                              " (change)="
                                onChangeNuevaClaseGlobal(
                                  $event,
                                  objClaseGlobal.clase
                                )
                              ">
                              <option *ngFor="let lst of clasesGlobalesSelect" [value]="lst.codigo">
                                {{ lst.codigo + " - " + lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0.5rem">
                          <!---->
                          <label for="fname2" style="
                              padding: 0.2em 0em 0em 0.5em;
                              margin-left: 25px;
                            " class="col-sm-2 control-label col-form-label tsiLabel">Segmento:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codCodigoGlobal"
                              type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseGlobal.codigo" />
                          </div>
                          <div class="col-sm-6">
                            <select tabindex="15" class="col-sm-12  tsiSelect" [(ngModel)]="objClaseGlobal.codigo"
                              name="codCodigoGlobal" #selectClaseGlobal style="
                                margin-bottom: 12px !important ;
                                padding-top: 0px !important;
                              ">
                              <option *ngFor="let lst of clasesCodigosGlobal" [value]="lst.codigo">
                                {{ lst.codigo + " - " + lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="form-group row" style="margin-bottom: 0.5rem">
                          <!---->
                          <label for="fname2" style="
                              padding: 0.2em 0em 0em 0.5em;
                              margin-left: 25px;
                            " class="col-sm-2 control-label col-form-label tsiLabel">Familia:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codCodigoGlobal"
                              type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseGlobal.codigo" />
                          </div>
                          <div class="col-sm-6">
                            <select tabindex="15" class="col-sm-12  tsiSelect" [(ngModel)]="objClaseGlobal.codigo"
                              name="codCodigoGlobal" #selectClaseGlobal style="
                                margin-bottom: 12px !important ;
                                padding-top: 0px !important;
                              ">
                              <option *ngFor="let lst of clasesCodigosGlobal" [value]="lst.codigo">
                                {{ lst.codigo + " - " + lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0.5rem">
                          <!---->
                          <label for="fname2" style="
                              padding: 0.2em 0em 0em 0.5em;
                              margin-left: 25px;
                            " class="col-sm-2 control-label col-form-label tsiLabel">Clase:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codCodigoGlobal"
                              type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseGlobal.codigo" />
                          </div>
                          <div class="col-sm-6">
                            <select tabindex="15" class="col-sm-12  tsiSelect" [(ngModel)]="objClaseGlobal.codigo"
                              name="codCodigoGlobal" #selectClaseGlobal style="
                                margin-bottom: 12px !important ;
                                padding-top: 0px !important;
                              ">
                              <option *ngFor="let lst of clasesCodigosGlobal" [value]="lst.codigo">
                                {{ lst.codigo + " - " + lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row" style="margin-bottom: 0.5rem">
                          <!---->
                          <label for="fname2" style="
                              padding: 0.2em 0em 0em 0.5em;
                              margin-left: 25px;
                            " class="col-sm-2 control-label col-form-label tsiLabel">Producto:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codCodigoGlobal"
                              type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseGlobal.codigo" />
                          </div>
                          <div class="col-sm-6">
                            <select tabindex="15" class="col-sm-12  tsiSelect" [(ngModel)]="objClaseGlobal.codigo"
                              name="codCodigoGlobal" #selectClaseGlobal style="
                                margin-bottom: 12px !important ;
                                padding-top: 0px !important;
                              ">
                              <option *ngFor="let lst of clasesCodigosGlobal" [value]="lst.codigo">
                                {{ lst.codigo + " - " + lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarClaseGlobalUNSPSC()"
                  tabindex="5">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15"
                  (click)="closeInsertclassGlobalUNSPSC()" (click)="modal.close('Save click')" tabindex="6">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>

            <ngb-tab *ngIf="tablistprecios">
              <ng-template ngbTabTitle>
                <span>Lista de precios</span></ng-template>
              <ng-template ngbTabContent>

                <div class="table-responsive" style="margin-top: 20px">
                  <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Título</th>
                        <th style="text-align: right">Precio</th>
                        <th style="text-align: right">Dsct1</th>
                        <th style="text-align: right">Dsct2</th>
                        <th style="text-align: right">Dsct3</th>
                        <th style="text-align: right">Dsct4</th>
                        <th style="text-align: right">Total neto</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let lst of listaPreciosArticulo">
                        <td>{{ lst.codart }}</td>
                        <td>{{ lst.destit }}</td>
                        <td style="text-align: right">
                          {{ lst.precio | decimalPipeComercialPrecio }}
                        </td>
                        <td style="text-align: right">
                          {{ lst.desc01 | decimalPipeComercialPrecio }}
                        </td>
                        <td style="text-align: right">
                          {{ lst.desc02 | decimalPipeComercialPrecio }}
                        </td>
                        <td style="text-align: right">
                          {{ lst.desc03 | decimalPipeComercialPrecio }}
                        </td>
                        <td style="text-align: right">
                          {{ lst.desc04 | decimalPipeComercialPrecio }}
                        </td>
                        <td style="text-align: right">
                          {{
                          this.calcular_precio_total(lst)
                          | decimalPipeComercialPrecio
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-template>
            </ngb-tab>
            <ngb-tab *ngIf="tablistprecios">
              <ng-template ngbTabTitle>
                <span>Detracción
                  <nav></nav>
                </span></ng-template>
              <ng-template ngbTabContent>
                <div class="modal-body">
                  <form>
                    <div class="row" style="margin-top: 20px">
                      <div class="col-md-12">
                        <div class="input-group">
                          <label class="label-size tsiLabel col-md-3">Tasa de detracción:
                          </label>
                          <input class="focus-input input_border form-control tsiInput form-control-sm mr-2 col-md-2"
                            #tasaI name="tasa" [(ngModel)]="detraccion.tasdet" type="text" tabindex="100" />
                          <select class="focus-input input_border form-control form-control-sm tsiSelect col-md-6"
                            [(ngModel)]="detraccion.tasdet" name="tasa" [disabled]="detracciondisabled" tabindex="101">
                            <option *ngFor="let lst of detracciones" [value]="lst.codfac">
                              {{ lst.codfac }}-{{ lst.nomfac }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="input-group">
                          <label class="label-size tsiLabel col-md-3">Tipo de operación:
                          </label>
                          <input class="focus-input input_border form-control tsiInput form-control-sm mr-2 col-md-2"
                            #claseI name="operacion" [(ngModel)]="detraccion.tipope" type="text" tabindex="102" />
                          <select class="focus-input input_border form-control form-control-sm tsiSelect col-md-6"
                            [(ngModel)]="detraccion.tipope" name="operacion" [disabled]="operaciondisabled"
                            tabindex="103">
                            <option *ngFor="let lst of operaciones" [value]="lst.codfac">
                              {{ lst.codfac }}-{{ lst.nomfac }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="input-group">
                          <label class="label-size tsiLabel col-md-3">Tipo de bien o servicio:
                          </label>
                          <input class="focus-input input_border form-control tsiInput form-control-sm mr-2 col-md-2"
                            #claseI name="bienservicio" [(ngModel)]="detraccion.tipbys" type="text" tabindex="104" />
                          <select class="focus-input input_border form-control form-control-sm tsiSelect col-md-6"
                            [(ngModel)]="detraccion.tipbys" name="bienservicio" [disabled]="bienserviciodisabled"
                            tabindex="105">
                            <option *ngFor="let lst of bienes_servicios" [value]="lst.codfac">
                              {{ lst.codfac }}-{{ lst.nomfac }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </ng-template>
            </ngb-tab>

            <ngb-tab *ngIf="tablistprecios">
              <ng-template ngbTabTitle>
                <span>Glosa
                  <nav></nav>
                </span></ng-template>
              <ng-template ngbTabContent>
                <div class="modal-body">
                  <form>
                    <button class="btn btn-rounded btn-info" style="margin-top: 5px;" (click)="guardarGlosa()"
                      tabindex="14">
                      <i class="fa fa-save"></i>&nbsp; Guardar Glosa
                    </button>

                    <div class="row m-t-20" style="margin-top: 30px;">
                      <div class="col-md-12">
                        <div class="input-group">
                          <!-- <input
                                                    class="focus-input input_border form-control tsiInput form-control-sm mr-2 col-md-2"
                                                    name="tipoglosa" [(ngModel)]="tipoglosa"type="text" tabindex="101">                -->
                          <select class="focus-input input_border form-control form-control-sm tsiSelect col-md-4"
                            [(ngModel)]="tipoglosa" name="tipoglosa" (change)="getGlosa()" tabindex="101">
                            <option value="1">
                              1 - Glosa para cotizaciones
                            </option>
                            <option value="2">
                              2 - Glosa para facturación
                            </option>
                            <option value="3">
                              3 - Glosa para presupuestos
                            </option>
                            <option value="4">
                              4 - Glosa para orden de pedido
                            </option>
                          </select>

                          <!-- <button class="btn btn-primary btn-sm boton m-b-5"
                                                            (click)="getGlosa()" type="button" tabindex="3"><i
                                                                class="fa fa-search"></i></button> -->
                        </div>
                      </div>
                    </div>
                    <hr />

                    <div class="row">
                      <div class="col-md-12">
                        <div class="input-group">
                          <br />
                          <textarea [disabled]="encontro" [(ngModel)]="glosa"
                            class="col-md-4 focus-input input_border form-control form-control-sm select_border"
                            id="glosa" name="glosa" type="text" rows="6" maxlength="980" tabindex="21"></textarea>

                          <label class="ui-checkbox" style="
                              margin-left: 10px;
                              margin-right: 10px !important;
                            ">
                            <input type="checkbox" (change)="
                                onChangePredeterminadoUpd($event.target.checked)
                              " [checked]="predeterminadoUpd" id="predeterminadoUpd" tabindex="302" />
                            <span class="input-span"></span>
                          </label>
                          <label style="margin-right: 0.5rem" for="predeterminadoUpd">Predeterminado</label>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="row" *ngIf="tipoglosa == '1'" >
                                            <div class="col-md-12">
                                                <div class="input-group">
                                                    <br>
                                                    <textarea [disabled]="encontro"   [(ngModel)]="glosacotizaciones"
                                                    class="col-md-4 focus-input input_border form-control  form-control-sm select_border"
                                                    id="glosacotizaciones" name="glosacotizaciones" placeholder="Glosa para cotizaciones"
                                                    style="text-transform:uppercase;" type="text" rows="6"
                                                    maxlength="980" tabindex="21"></textarea>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row"  *ngIf="tipoglosa == '2'" >
                                            <div class="col-md-12">
                                                <div class="input-group">
                                                    <br>
                                                    <textarea [disabled]="encontro"   [(ngModel)]="glosafacturacion"
                                                    class="col-md-4 focus-input input_border form-control  form-control-sm select_border"
                                                    id="glosafacturacion" name="glosafacturacion" placeholder="Glosa para facturación"
                                                    style="text-transform:uppercase;" type="text" rows="6"
                                                    maxlength="980" tabindex="21"></textarea>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row"  *ngIf="tipoglosa == '3'" >
                                            <div class="col-md-12">
                                                <div class="input-group">
                                                    <br>
                                                    <textarea [disabled]="encontro"   [(ngModel)]="glosapresupuestos"
                                                            class="col-md-4 focus-input input_border form-control  form-control-sm select_border"
                                                            id="glosapresupuestos" name="glosapresupuestos" placeholder="Glosa para presupuestos"
                                                            style="text-transform:uppercase;" type="text" rows="6"
                                                            maxlength="980" tabindex="21"></textarea>
                                                </div>
                                            </div>
                                        </div>  -->
                    <div class="modal-footer">
                      <!-- <button (click)="eliminarGlosas()" [hidden]="mostrarbotoneliminar" type="button"
                                            class="btn btn-rounded btn-danger m-b-15"><i class="fa fa-trash"></i>
                                            Eliminar Glosas</button> -->
                    </div>
                  </form>
                </div>
              </ng-template>
            </ngb-tab>

            <ngb-tab *ngIf="tabimagenes">
              <ng-template ngbTabTitle> <span>Adjuntos</span></ng-template>
              <ng-template ngbTabContent>
                <div class="col-md-12">
                  <!-- <button tabindex="15" class="btn btn-rounded btn-info mr-3" type="button" id="loadFileXml" value="loadXml"
                                    onclick="document.getElementById('file').click();"><i class="fas fa-upload"
                                        style="margin-right: .3rem"></i> Importar documento</button> -->
                  <button tabindex="15" class="btn btn-rounded btn-info" type="button" id="loadFile" value="load"
                    style="margin-top: 20px;" onclick="document.getElementById('file2').click();">
                    <i class="fas fa-upload" style="margin-right: 0.3rem"></i>
                    Importar archivo
                  </button>
                  <input type="file" style="display: none" id="file2" name="file2" accept=".jpg,.pdf,.xml,.xlsx,.xlsm"
                    multiple (change)="handleFileInput($event.target.files)" (click)="onInputClick($event)" />

                  <!-- <input  #fileUpload type="file" id="file" accept=".jpg,.pdf"
                                                        (change)="uploadImage($event)">


                                        <button [disabled]="boolguardar" class="btn btn-rounded btn-info m-b-15" (click)="agregarImagen()"
                                        style="width: 115px; margin-right: 50px; margin-top: 10px;"
                                        tabindex="14"><i
                                            class="fa fa-save"></i>&nbsp; Guardar</button> -->


                  <!-- <input type="text" placeholder="Buscar ..." class="form-control col-md-6" (keydown)="onChange($event.target.value)" [(ngModel)]="csearchTerm" name="csearchTerm"> -->
                  <div class="table-responsive" style="height: 55vh">
                    <table class="table table-sm table-striped table-bordered table-hover " style="margin-top: 30px;">
                      <thead>
                        <tr>
                          <th class="text-center"></th>
                          <th>Item</th>
                          <th>Formato</th>
                          <th>Nombre</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="cursor" *ngFor="let lst of doc_adjuntos">
                          <td style="text-align: center">
                            <div class="btn-group dropright" ngbDropdown container="body" role="group"
                              aria-label="Button group with nested dropdown" style="margin: 0px; padding: 0px">
                              <button class="btn btn-sm" ngbDropdownToggle style="margin: 0px; padding: 0px">
                                <i class="fas fa-align-left"></i>
                              </button>
                              <ul class="dropdown-menu" ngbDropdownMenu>
                                <li>
                                  <a class="dropdown-item" href="javascript:;" style="width: 84%"
                                    (click)="eliminarAdj(lst)">
                                    <i style="width: 84%" class="fas fa-trash-alt"
                                      style="margin-right: 0.3rem"></i>Eliminar</a>
                                </li>
                                <li>
                                  <a class="dropdown-item" href="javascript:;" style="width: 84%"
                                    (click)="descargarAdj(lst)">
                                    <i style="width: 84%" class="fas fa-download"
                                      style="margin-right: 0.3rem"></i>Descargar</a>
                                </li>
                              </ul>
                            </div>
                          </td>
                          <td style="white-space: nowrap;" class="text-left">{{lst.id}}</td>
                          <td style="white-space: nowrap;" class="text-left">{{lst.formato}}
                          </td>
                          <td style="white-space: nowrap;" class="text-left">{{lst.nombre}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-template>
            </ngb-tab>

            <ngb-tab *ngIf="tabclases">
              <ng-template ngbTabTitle> <span>EAN</span></ng-template>
              <ng-template ngbTabContent>
                <button type="button" class="btn btn-rounded btn-success " style="margin-top: 20px;"
                  (click)="openNuevoClase(modalnuevaEAN)">
                  <i class="fa fa-plus"></i> Nuevo
                </button>

                <div class="table-responsive" style="height: 50vh">
                  <table class="table table-sm table-striped table-bordered table-hover" style="margin-top: 30px;">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Item</th>
                        <th>EAN</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of listean">
                        <td scope="row" style="
                            display: table-cell;
                            text-align: center;
                            padding-bottom: 0px;
                          ">
                          <div class="btn-group btn-group-xs" role="group" style="margin: 0px; padding: 0px">
                            <button type="button" style=" border: none; outline: none;" class="btn btn-sm"
                              (click)="openUpdate2(item, modalnuevaEAN)">
                              <span class="fas fa-pencil-alt" aria-hidden="true"></span>
                            </button>
                            <button type="button" style=" border: none; outline: none;" class="btn btn-sm"
                              (click)="EliminarEAN(item)">
                              <span class="fas fa-trash-alt" aria-hidden="true"></span>
                            </button>
                          </div>
                        </td>
                        <td scope="row">{{ item.item }}</td>
                        <td style="white-space: nowrap">{{ item.ean }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-template>
            </ngb-tab>

            <ng-template #modalnuevaEAN let-modal>
              <div class="">
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 *ngIf="newClase" class="modal-title">
                      <b>Nueva EAN</b>
                    </h4>
                    <h4 *ngIf="!newClase" class="modal-title">
                      <b>Editar EAN</b>
                    </h4>

                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"
                      tabindex="200">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body pl-4">
                    <form>
                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                        <!---->
                        <label for="fname2" class="col-md-1 label-size tsiLabel mt-2">Item:</label>
                        <div class="col-sm-2">
                          <input class="form-control tsiInput" name="codClase" type="text" tabindex="201"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                            [(ngModel)]="objEAN.item" />
                        </div>
                      </div>

                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                        <label for="fname2" class="col-md-1 label-size tsiLabel mt-2">EAN:</label>
                        <div class="col-sm-5">
                          <input style="text-align: left" class="form-control tsiInput" name="codCodigo" type="text"
                            tabindex="203" maxlength="12" [(ngModel)]="objEAN.ean" />
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="modal-footer">
                    <button *ngIf="newClase" type="button" class="btn btn-rounded btn-success m-b-15"
                      (click)="guardarEAN()" tabindex="205">
                      <i class="fas fa-angle-double-right"></i> Continuar
                    </button>
                    <button *ngIf="!newClase" type="button" class="btn btn-rounded btn-success m-b-15"
                      (click)="edtarEAN()" tabindex="205">
                      <i class="fas fa-angle-double-right"></i> Guardar
                    </button>

                    <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertclass()"
                      (click)="modal.close('Save click')" tabindex="206">
                      <i class="fa fa-times-circle"></i> Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template #modalactualizarclase let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Modificar Clase:
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row" style="margin-bottom: 0.5rem">
                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em 0.5em"
                            class="col-sm-1 control-label col-form-label tsiLabel">Clase:</label>
                          <div class="col-sm-1">
                            <input class="form-control tsiInput" name="codClase" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseCodigoDescripcion.clase" disabled />
                          </div>
                          <div class="col-sm-4">
                            <!--  <select disabled tabindex="15" class="custom-select"  class="form-control tsiInput"  [(ngModel)]="objClaseCodigoDescripcion.clase"
                                name="codClase" #selectClase  style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                >
                                <option *ngFor="let lst of clasesSelect " [value]="lst.codigo" >
                                {{lst.codigo+' - '+lst.descri}}
                                </option>
                            </select> -->
                            <input style="text-align: center" class="form-control t" name="desClase" type="text"
                              [(ngModel)]="objClaseCodigoDescripcion.desclase" disabled />
                          </div>

                          <!---->
                          <label for="fname2" style="padding: 0.2em 0em 0em 0.5em"
                            class="col-sm-1 control-label col-form-label tsiLabel">Código:</label>
                          <div class="col-sm-1">
                            <input style="text-align: center" class="form-control tsiInput" name="codigo" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"
                              [(ngModel)]="objClaseCodigoDescripcion.codigo" />
                          </div>
                          <div class="col-sm-4">
                            <select tabindex="15" class="col-sm-12  tsiSelect"
                              [(ngModel)]="objClaseCodigoDescripcion.codigo" name="codigo" #selectClase style="
                                margin-bottom: 12px !important ;
                                padding-top: 0px !important;
                              ">
                              <option *ngFor="let lst of clasesCodigos" [value]="lst.codigo">
                                {{ lst.codigo + " - " + lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarActualizarClase()"
                  tabindex="5">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertclass()"
                  (click)="modal.close('Save click')" tabindex="6">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>
          </ngb-tabset>
        </div>
      </div>
    </div>
  </div>
</div>